import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { trackHeroShown } from '../analytics.ts'
import { liveHero } from '../hero/live.ts'
import { useLandingStart } from '../screens/landing.tsx'
import { validateSearch } from '../search.ts'

/** The hero comes from the registry (hero/versions.ts) and the running A/B test (hero/tests.ts). */
export const Route = createFileRoute('/')({
  validateSearch,
  loaderDeps: ({ search }) => ({ v: search.v }),
  loader: ({ deps }) => liveHero(deps.v),
  component: HookScreen,
})

function HookScreen() {
  const { choice, Hero } = Route.useLoaderData()
  const urlSearch = Route.useSearch()
  // The drawn arm is not written into the address (storage keeps it); the view and the lead
  // still need it.
  const landing = useLandingStart(choice.variant ? { ...urlSearch, v: choice.variant } : urlSearch)
  useEffect(() => trackHeroShown(choice), [choice])
  return <Hero {...landing} />
}
